import * as icons from "@ant-design/icons";
import { keys } from "lodash";

export const antd = {
  /**
   * Antd 4.0 Icon 清單名稱
   * @returns {array} antd 4.0 的 icon 元件名稱
   */
  icons: keys(icons).filter(icon => icon.match(/^\w+(Filled|TwoTone|Outlined)$/g)),
  /**
   * 取得 Antd 4.0 Icon 元件
   * @param {string} iconName - icon 元件名稱
   * @returns
   */
  getIconComponent(iconName) {
    return icons[iconName];
  },

  /**
   * 產生針對 Antd Form List 的 setFieldsValue 方法
   * @param {object} form - Antd Form 物件
   * @param {string} listName - Antd Form List 名稱
   * @returns {function} 設定 Form List 中的物件欄位方法
   */
  genSetFormListFieldsValue(form, listName) {
    /**
     * 設定 Form List 中的物件欄位方法
     * @param {string} fieldName - Form List 中的物件欄位名稱
     * @param {object} values - 要設定的欄位值
     * @param {array} revalidateFieldNames - 要驗證的欄位名稱
     */
    return (listFieldName, values) => {
      const list = form.getFieldsValue()[listName];
      Object.assign(list[listFieldName], values);
      form.setFieldsValue({ [listName]: list });
    };
  },
  /**
   * 產生針對 Antd Form List 的 validateFields 方法
   * @param {object} form - Antd Form 物件
   * @param {string} listName - Antd Form List 名稱
   * @returns {function} 驗證 Form List 中的物件欄位方法
   */
  genValidateFormListFields(form, listName) {
    return (listFieldName, fieldNames) =>
      form.validateFields(fieldNames.map(fieldName => [listName, listFieldName, fieldName]));
  }
};
